// src/firebase.js
import { initializeApp } from "firebase/app";
import { 
  getAuth, 
  setPersistence, 
  browserLocalPersistence 
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage"; // ✅ add storage

// ✅ Your Firebase config (from Firebase Console)
const firebaseConfig = {
  apiKey: "AIzaSyC_6qdtFMcCM8rPueInRPttQiu9tzx5izU",
  authDomain: "familytree-78a73.firebaseapp.com",
  projectId: "familytree-78a73",
  storageBucket: "familytree-78a73.firebasestorage.app", // ✅ ensure correct bucket
  messagingSenderId: "745096587006",
  appId: "1:745096587006:web:bc807cfb5b782d33b9a7af"
};



// ✅ Initialize Firebase
const app = initializeApp(firebaseConfig);

// ✅ Initialize Auth, Firestore & Storage
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app); // ✅ now available

// ✅ Keep user logged in after refresh
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log("Auth persistence set to LOCAL ✅");
  })
  .catch((error) => {
    console.error("Error setting persistence:", error);
  });